var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"background-image-search",staticStyle:{"background-image":"url(img/temp/blurred-dark.jpg)"}}),_c('CollectionList',{attrs:{"searchUri":'collections/getAllCollections',"binder":this.$store.state.collections.all,"payload":{ 'userId': this.$store.state.authentication.user.user.id }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }